import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Terminated from "../../components/Terminated/Terminated";
import { initChatStatus } from "#src/modules/reducers/chat/agent/connectChatServer.js";
import { initUserChannelId } from "#src/modules/reducers/parseUrl.js";
import { initChatbot } from "#src/modules/reducers/chat/bot/initForNobrand.js";
import { setInit } from "#src/modules/reducers/arsUrlValidator/checkArsStatus.js";

const ExpiredPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initChatStatus());
    dispatch(initUserChannelId());
    dispatch(initChatbot());
    dispatch(setInit());
  }, [])

  return (
    <Terminated
      title="만료된 상담입니다."
      description={[
        "ARS 연결을 통해 다시 상담이 가능합니다.",
      ]}
    />
  );
};

export default ExpiredPage;
